import {observable, action, autorun} from 'mobx';

let loadTimer;

let UI = observable({
  hideHeader: false,
  homepageReady: false,
  hasIntroFlag: true,
  showIntroPadding: true,
  isMobile: window.innerWidth <= 768,
  isMobileSmall: window.innerWidth <= 545,
  isTouch: 'ontouchstart' in document.documentElement,
  isLoading: false,
  headerIsScaling: true,
  showIntroPrompt: true,
  isProjectOpen: null
})

const onFirstTouch = () => {
  UI.isTouch = true
  document.body.classList.add('touch')
  window.removeEventListener('touchstart', onFirstTouch, false)
}
window.addEventListener('touchstart', onFirstTouch)

window.addEventListener('resize', e => {
  UI.isMobileSmall = window.innerWidth <= 545
  UI.isMobile = window.innerWidth <= 768
  UI.isLetterbox = window.innerHeight / window.innerWidth <= 0.5
})

UI.updateLoading = action(function (bool, from) {

  if (bool) {
    clearTimeout(loadTimer)
    loadTimer = setTimeout(() => {
      UI.isLoading = bool
    }, 300)
  } else {
    clearTimeout(loadTimer)
    UI.isLoading = bool
  }
})

UI.homepageExists = action(function () {
  UI.homepageReady = true
})

UI.listenToTransform = action(function (bool) {
  UI.headerIsScaling = bool
})

UI.togglePrompt = action(function (bool) {
  UI.showIntroPrompt = bool
})

UI.toggleProjectViewStatus = action(function (bool) {
  UI.isProjectOpen = bool
})

UI.toggleIntroPadding = action(function (bool) {
  UI.showIntroPadding = bool
})

export default UI



// WEBPACK FOOTER //
// ./app/javascript/packs/stores/UI.js